import { render } from "./cvsPage.vue?vue&type=template&id=2396dab5&scoped=true"
import script from "./cvsPage.vue?vue&type=script&lang=js"
export * from "./cvsPage.vue?vue&type=script&lang=js"

import "./cvsPage.vue?vue&type=style&index=0&id=2396dab5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2396dab5"]])

export default __exports__